import { Text } from "@/components/text/text.component";

export function ProductCardOverlays({ badges }: ProductCardOverlaysProps) {
  const allBadges = badges ?? [];

  if (allBadges.length === 0) return null;

  return (
    <div className="absolute top-4 left-4 z-10 flex flex-wrap gap-2">
      {allBadges.map((badge) => (
        <div
          key={badge}
          className="text-secondary rounded-full bg-white px-2 py-1 text-sm">
          <Text variant="body4" className="font-thin">
            {badge}
          </Text>
        </div>
      ))}
    </div>
  );
}

export type ProductCardOverlaysProps = {
  badges?: string[];
};
